import React, { useState, useMemo } from "react";

// ─── COMPREHENSIVE COURSE CATALOG DATA ─────────────────────────────────────────

export const COURSES_DATA = [
  // ── 1. TEACHER TRAINING ─────────────────────────────────────────────
  {
    id: "ntt",
    title: "Nursery Teachers Training (NTT)",
    kn: "ನರ್ಸರಿ ಶಿಕ್ಷಕರ ತರಬೇತಿ ಡಿಪ್ಲೊಮಾ",
    category: "Teacher Training",
    duration: "1 Year",
    eligibility: "10th / 12th Pass",
    mode: "Regular / Weekend / Distance",
    badge: "Most Popular",
    badgeColor: "bg-red-100 text-red-700 border-red-200",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&auto=format&fit=crop&q=80",
    desc: "Government approved diploma preparing aspiring teachers for preschools, kindergarten, and play schools with modern teaching methodologies.",
    highlights: [
      "Govt. Recognized Certification",
      "100% Placement Assistance in 20,000+ Partner Schools",
      "Practical teaching aids, rhymes, and storytelling techniques",
      "Child psychology, nutrition, and early childhood care",
      "Classroom internship and project work"
    ],
    careers: "Preschool Teacher, Nursery Educator, Daycare Coordinator, Anganwadi Supervisor"
  },
  {
    id: "mtt",
    title: "Montessori Teachers Training (MTT)",
    kn: "ಮಾಂಟೆಸ್ಸರಿ ಶಿಕ್ಷಕರ ತರಬೇತಿ",
    category: "Teacher Training",
    duration: "1 Year",
    eligibility: "10th / 12th / Any Pass",
    mode: "Regular / Weekend",
    badge: "Govt. Approved",
    badgeColor: "bg-blue-100 text-blue-700 border-blue-200",
    image: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=600&auto=format&fit=crop&q=80",
    desc: "Comprehensive training in Maria Montessori philosophy, sensorial apparatus handling, and self-directed child development.",
    highlights: [
      "Hands-on Montessori apparatus workshop",
      "Sensorial, math, language, and cultural exercises",
      "Montessori classroom environment setup",
      "Child-centered observational techniques",
      "Nationally accepted teacher diploma"
    ],
    careers: "Montessori Directress, Early Childhood Educator, Activity Center Lead"
  },
  {
    id: "ptt",
    title: "Primary Teachers Training (PTT)",
    kn: "ಪ್ರಾಥಮಿಕ ಶಿಕ್ಷಕರ ತರಬೇತಿ",
    category: "Teacher Training",
    duration: "2 Years",
    eligibility: "12th Pass / Any Degree",
    mode: "Regular / Distance",
    badge: "High Demand",
    badgeColor: "bg-emerald-100 text-emerald-700 border-emerald-200",
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600&auto=format&fit=crop&q=80",
    desc: "Structured pedagogy curriculum designed for teaching students in classes 1st to 5th across CBSE, ICSE, and State Board schools.",
    highlights: [
      "Primary school curriculum & pedagogy across core subjects",
      "Educational psychology and classroom management",
      "Digital learning tools and audio-visual instructional methods",
      "Student assessment & evaluation techniques",
      "Micro-teaching practice sessions"
    ],
    careers: "Primary School Teacher, Private Tutor, Academic Curriculum Developer"
  },
  {
    id: "dsa",
    title: "Diploma in School Administration & Management",
    kn: "ಶಾಲಾ ಆಡಳಿತ ಮತ್ತು ನಿರ್ವಹಣೆ ಡಿಪ್ಲೊಮಾ",
    category: "Teacher Training",
    duration: "1 Year",
    eligibility: "Graduates / Experienced Teachers",
    mode: "Distance / Online",
    badge: "Career Booster",
    badgeColor: "bg-purple-100 text-purple-700 border-purple-200",
    image: "https://images.unsplash.com/photo-1562516155-e0c1ee44059b?w=600&auto=format&fit=crop&q=80",
    desc: "Leadership and institutional management program for aspiring principals, coordinators, and school administrators.",
    highlights: [
      "School leadership, human resource, and staff management",
      "Affiliation procedures, education board regulations & compliance",
      "Financial planning, school budgeting & fee administration",
      "Parent-community communication & crisis management",
      "Quality assurance and educational policy implementation"
    ],
    careers: "School Vice Principal, Academic Coordinator, Admin Officer, Center Head"
  },
  {
    id: "ytt",
    title: "Yoga Teachers Training (YTT)",
    kn: "ಯೋಗ ಶಿಕ್ಷಕರ ತರಬೇತಿ",
    category: "Teacher Training",
    duration: "1 Year",
    eligibility: "10th / 12th / Any Stream",
    mode: "Weekend / Regular",
    badge: "Certified",
    badgeColor: "bg-amber-100 text-amber-700 border-amber-200",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&auto=format&fit=crop&q=80",
    desc: "Holistic yoga instructor course covering classical asanas, pranayama, anatomy, meditation, and yoga philosophy.",
    highlights: [
      "Asana alignment, sequencing, and correction techniques",
      "Pranayama, mudras, bandhas, and yogic kriyas",
      "Human anatomy, physiology, and therapeutic yoga",
      "Patanjali Yoga Sutras and yogic diet principles",
      "Certification eligible for schools, fitness studios & self-practice"
    ],
    careers: "School Yoga Instructor, Corporate Wellness Coach, Yoga Studio Trainer"
  },

  // ── 2. UNDERGRADUATE DEGREES (UG) ──────────────────────────────────
  {
    id: "ba",
    title: "Bachelor of Arts (BA)",
    kn: "ಬ್ಯಾಚುಲರ್ ಆಫ್ ಆರ್ಟ್ಸ್ (ಬಿ.ಎ)",
    category: "Undergraduate (UG)",
    duration: "3 Years",
    eligibility: "12th / PUC Pass (Any stream)",
    mode: "Distance / Open Education",
    badge: "UGC Approved",
    badgeColor: "bg-blue-100 text-blue-700 border-blue-200",
    image: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=600&auto=format&fit=crop&q=80",
    desc: "Flexible undergraduate degree in humanities with specializations in Kannada, English, History, Economics, and Political Science.",
    highlights: [
      "Choice of multiple subject combinations",
      "Weekend contact sessions & comprehensive study materials",
      "Recognized for all Government job competitive exams (KPSC, UPSC, FDA, SDA)",
      "Direct entry for working professionals and private candidates"
    ],
    careers: "Govt Civil Services, Teaching, Content Writing, Public Administration"
  },
  {
    id: "bcom",
    title: "Bachelor of Commerce (B.Com)",
    kn: "ಬ್ಯಾಚುಲರ್ ಆಫ್ ಕಾಮರ್ಸ್ (ಬಿ.ಕಾಂ)",
    category: "Undergraduate (UG)",
    duration: "3 Years",
    eligibility: "12th / PUC Pass (Commerce / Science)",
    mode: "Distance / Online",
    badge: "High Enrolment",
    badgeColor: "bg-green-100 text-green-700 border-green-200",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&auto=format&fit=crop&q=80",
    desc: "Strong foundation in financial accounting, taxation, auditing, company law, and business management.",
    highlights: [
      "Financial accounting, corporate accounting, and cost accounting",
      "Indian taxation laws, GST regulations, and business statistics",
      "Corporate law, banking operations, and financial markets",
      "Foundation for CA, CS, ICWA, and MBA aspirants"
    ],
    careers: "Accountant, Financial Analyst, Banking Executive, Tax Consultant"
  },
  {
    id: "bca",
    title: "Bachelor of Computer Applications (BCA)",
    kn: "ಬ್ಯಾಚುಲರ್ ಆಫ್ ಕಂಪ್ಯೂಟರ್ ಅಪ್ಲಿಕೇಶನ್ಸ್ (ಬಿಸಿಎ)",
    category: "Undergraduate (UG)",
    duration: "3 Years",
    eligibility: "12th / PUC Pass",
    mode: "Distance / Online",
    badge: "Tech Career",
    badgeColor: "bg-indigo-100 text-indigo-700 border-indigo-200",
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&auto=format&fit=crop&q=80",
    desc: "Practical software development program covering programming languages, web development, and database administration.",
    highlights: [
      "C, C++, Java, and Python programming fundamentals",
      "Web technologies (HTML, CSS, JavaScript) & Database Management (SQL)",
      "Operating systems, data structures, and computer networking",
      "Real-world software development project work"
    ],
    careers: "Software Developer, Web Designer, IT Support Specialist, System Analyst"
  },
  {
    id: "bsc",
    title: "Bachelor of Science (B.Sc)",
    kn: "ಬ್ಯಾಚುಲರ್ ಆಫ್ ಸೈನ್ಸ್ (ಬಿ.ಎಸ್ಸಿ)",
    category: "Undergraduate (UG)",
    duration: "3 Years",
    eligibility: "12th / PUC (Science stream)",
    mode: "Distance / Flexible",
    badge: "UGC Approved",
    badgeColor: "bg-teal-100 text-teal-700 border-teal-200",
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=600&auto=format&fit=crop&q=80",
    desc: "Science degree empowering students with analytical and scientific principles across physical and mathematical sciences.",
    highlights: [
      "Physics, Chemistry, Mathematics, and Computer Science streams",
      "Practical demonstration workshops and conceptual guidance",
      "Eligible for B.Ed, M.Sc, and scientific officer exams"
    ],
    careers: "Science Educator, Lab Technician, Data Assistant, Research Associate"
  },
  {
    id: "blib",
    title: "Bachelor of Library & Information Science (B.Lib.I.Sc)",
    kn: "ಬ್ಯಾಚುಲರ್ ಆಫ್ ಲೈಬ್ರರಿ ಸೈನ್ಸ್ (ಬಿ.ಲಿಬ್)",
    category: "Undergraduate (UG)",
    duration: "1 Year",
    eligibility: "Any Bachelor's Degree",
    mode: "Distance Education",
    badge: "Fast Track",
    badgeColor: "bg-orange-100 text-orange-700 border-orange-200",
    image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=600&auto=format&fit=crop&q=80",
    desc: "Fast-track 1-year professional degree for graduates aspiring to work in university, school, or public libraries.",
    highlights: [
      "Library classification (Dewey Decimal / Colon) & cataloguing",
      "Digital library software and metadata management",
      "Information retrieval systems and archival documentation",
      "High placement rate in institutional and govt libraries"
    ],
    careers: "Librarian, Library Assistant, Information Officer, Documentation Specialist"
  },

  // ── 3. POSTGRADUATE DEGREES (PG) ────────────────────────────────────
  {
    id: "ma",
    title: "Master of Arts (MA)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಆರ್ಟ್ಸ್ (ಎಂ.ಎ)",
    category: "Postgraduate (PG)",
    duration: "2 Years",
    eligibility: "Any Degree Graduate",
    mode: "Distance Education",
    badge: "UGC Recognized",
    badgeColor: "bg-blue-100 text-blue-700 border-blue-200",
    image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=600&auto=format&fit=crop&q=80",
    desc: "Advanced masters program in literature, history, and social sciences, ideal for teachers aiming for promotion or lecturer roles.",
    highlights: [
      "Specializations: Kannada, English, History, Sociology, Political Science",
      "In-depth research methodology and literature critical analysis",
      "Eligible for UGC-NET, KSET, and college lecturer appointments",
      "Flexible self-paced study designed for working teachers"
    ],
    careers: "College Lecturer, High School Senior Teacher, Researcher, Writer"
  },
  {
    id: "mcom",
    title: "Master of Commerce (M.Com)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಕಾಮರ್ಸ್ (ಎಂ.ಕಾಂ)",
    category: "Postgraduate (PG)",
    duration: "2 Years",
    eligibility: "B.Com / BBA Graduate",
    mode: "Distance / Online",
    badge: "Corporate Ready",
    badgeColor: "bg-emerald-100 text-emerald-700 border-emerald-200",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&auto=format&fit=crop&q=80",
    desc: "Specialized postgraduate studies in accounting, business finance, taxation, and international commerce.",
    highlights: [
      "Advanced corporate accounting and financial reporting standards",
      "Strategic cost management, direct tax laws, and GST compliance",
      "Security analysis, portfolio management, and banking policy",
      "Qualifies for college commerce lecturing (NET/SLET)"
    ],
    careers: "Senior Accountant, Financial Controller, Commerce Lecturer, Auditor"
  },
  {
    id: "mba",
    title: "Master of Business Administration (MBA)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಬಿಸಿನೆಸ್ ಅಡ್ಮಿನಿಸ್ಟ್ರೇಷನ್ (ಎಂಬಿಎ)",
    category: "Postgraduate (PG)",
    duration: "2 Years",
    eligibility: "Any Degree with 50%",
    mode: "Distance / Hybrid",
    badge: "High Growth",
    badgeColor: "bg-purple-100 text-purple-700 border-purple-200",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&auto=format&fit=crop&q=80",
    desc: "Executive business qualification designed to develop leadership, strategic management, and corporate decision-making skills.",
    highlights: [
      "Specializations in Human Resources (HR), Marketing, and Finance",
      "Strategic management, operations, and organizational behavior",
      "Case studies, leadership seminars, and business analytics",
      "High ROI for career advancement across private & public sectors"
    ],
    careers: "Business Manager, HR Manager, Marketing Director, Operations Lead"
  },
  {
    id: "mca",
    title: "Master of Computer Applications (MCA)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಕಂಪ್ಯೂಟರ್ ಅಪ್ಲಿಕೇಶನ್ಸ್ (ಎಂಸಿಎ)",
    category: "Postgraduate (PG)",
    duration: "2 Years",
    eligibility: "BCA / B.Sc / Graduate with Mathematics",
    mode: "Distance / Online",
    badge: "High Demand",
    badgeColor: "bg-indigo-100 text-indigo-700 border-indigo-200",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600&auto=format&fit=crop&q=80",
    desc: "Premier postgraduate technology degree focusing on modern enterprise software architecture and computational science.",
    highlights: [
      "Enterprise Java, Python frameworks, and cloud architectures",
      "Mobile app development, AI fundamentals, and full-stack engineering",
      "Database administration, data security, and Agile workflows",
      "Industry capstone project development"
    ],
    careers: "Senior Software Engineer, Systems Architect, Project Lead, IT Consultant"
  },
  {
    id: "msc",
    title: "Master of Science (M.Sc)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಸೈನ್ಸ್ (ಎಂ.ಎಸ್ಸಿ)",
    category: "Postgraduate (PG)",
    duration: "2 Years",
    eligibility: "B.Sc in relevant subject",
    mode: "Distance / Flexible",
    badge: "UGC Approved",
    badgeColor: "bg-teal-100 text-teal-700 border-teal-200",
    image: "https://images.unsplash.com/photo-1507668077129-56e32842fceb?w=600&auto=format&fit=crop&q=80",
    desc: "Rigorous scientific postgraduate program with choices in Mathematics, Physics, Chemistry, and Computer Science.",
    highlights: [
      "Advanced mathematical modeling, theoretical concepts, and research papers",
      "Direct eligibility for CSIR-NET and academic lecturer positions",
      "Flexible schedule for working educators and laboratory staff"
    ],
    careers: "Senior Lecturer, Research Analyst, Quality Control Chemist, Data Scientist"
  },
  {
    id: "mlib",
    title: "Master of Library Science (M.Lib.I.Sc)",
    kn: "ಮಾಸ್ಟರ್ ಆಫ್ ಲೈಬ್ರರಿ ಸೈನ್ಸ್ (ಎಂ.ಲಿಬ್)",
    category: "Postgraduate (PG)",
    duration: "1 Year",
    eligibility: "B.Lib.I.Sc Graduate",
    mode: "Distance Education",
    badge: "Expert Level",
    badgeColor: "bg-orange-100 text-orange-700 border-orange-200",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&auto=format&fit=crop&q=80",
    desc: "Postgraduate degree focusing on automated information systems, institutional repository management, and research data archiving.",
    highlights: [
      "Library automation networks, open-source software (Koha, DSpace)",
      "Digital rights management, information literacy, and e-resource archiving",
      "Eligibility for Chief Librarian roles in universities and Govt. institutions"
    ],
    careers: "Chief Librarian, Information Scientist, University Library Director"
  },

  // ── 4. OPEN SCHOOLING (10th / 12th) ─────────────────────────────────
  {
    id: "tenth",
    title: "10th Correspondence (SSLC)",
    kn: "10ನೇ ತರಗತಿ ಕರೆಸ್ಪಾಂಡೆನ್ಸ್ (ಎಸ್.ಎಸ್.ಎಲ್.ಸಿ)",
    category: "Open Schooling",
    duration: "1 Year / Direct Entry",
    eligibility: "Age 14+ years (School dropouts / private)",
    mode: "Distance / Weekend Support",
    badge: "Govt. Approved Board",
    badgeColor: "bg-green-100 text-green-700 border-green-200",
    image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=600&auto=format&fit=crop&q=80",
    desc: "Complete your secondary school education (SSLC / 10th standard) through a government-recognized open schooling board.",
    highlights: [
      "Government recognized marks card valid for all jobs & higher education",
      "Kannada & English medium options with textbook support",
      "Special weekend revision classes & past paper solving",
      "Direct admission without age ceiling"
    ],
    careers: "Eligible for PUC / 12th, ITI, Diploma courses, and Govt. Group-D jobs"
  },
  {
    id: "twelfth",
    title: "12th Correspondence (PUC / Senior Secondary)",
    kn: "12ನೇ ತರಗತಿ ಕರೆಸ್ಪಾಂಡೆನ್ಸ್ (ಪಿಯುಸಿ)",
    category: "Open Schooling",
    duration: "1 Year / Direct Entry",
    eligibility: "10th / SSLC Pass",
    mode: "Distance / Weekend Support",
    badge: "Direct Admission",
    badgeColor: "bg-blue-100 text-blue-700 border-blue-200",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&auto=format&fit=crop&q=80",
    desc: "Pass Pre-University Course (PUC / 12th) with flexible study schedules in Arts or Commerce streams.",
    highlights: [
      "Arts (History, Economics, Pol. Sci, Kannada, English) & Commerce streams",
      "Valid for all university degree admissions (BA, B.Com, BCA, BBA, NTT)",
      "Recognized for competitive exams including Police Constable, SDA, Railway",
      "Exam guidance, doubt clearance, and previous question papers provided"
    ],
    careers: "Gateway to Degrees (BA, B.Com, BCA, NTT, MTT), Police & Banking jobs"
  },

  // ── 5. COMPUTER & SKILL CERTIFICATIONS ──────────────────────────────
  {
    id: "tally",
    title: "Basic Tally Prime & GST Certification",
    kn: "ಬೇಸಿಕ್ ಟ್ಯಾಲಿ ಪ್ರೈಮ್ ಮತ್ತು ಜಿಎಸ್ಟಿ",
    category: "Computer & Skills",
    duration: "2 to 6 Months",
    eligibility: "10th / 12th / Any Stream",
    mode: "Hands-on Practical Labs",
    badge: "100% Job Oriented",
    badgeColor: "bg-red-100 text-red-700 border-red-200",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&auto=format&fit=crop&q=80",
    desc: "Complete accounting software training on Tally Prime with real GST return filing, payroll processing, and inventory management.",
    highlights: [
      "Ledgers, vouchers, trial balance, and balance sheet preparation",
      "Practical GST calculation, GSTR-1, GSTR-3B, and e-way billing",
      "Inventory batch tracking, stock godowns, purchase & sales orders",
      "Employee payroll computation, PF & ESI reports, bank reconciliation",
      "Hands-on computer lab sessions with State Board recognized certificate"
    ],
    careers: "Tally Operator, Accounts Assistant, Billing Executive, GST Practitioner"
  },
  {
    id: "msoffice",
    title: "Certificate in Office Automation & MS Office",
    kn: "ಕಂಪ್ಯೂಟರ್ ಬೇಸಿಕ್ & ಎಂಎಸ್ ಆಫೀಸ್",
    category: "Computer & Skills",
    duration: "3 Months",
    eligibility: "Anyone seeking essential computer skills",
    mode: "Practical Computer Labs",
    badge: "Essential Skill",
    badgeColor: "bg-emerald-100 text-emerald-700 border-emerald-200",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&auto=format&fit=crop&q=80",
    desc: "Master computer fundamentals, Windows OS, MS Word, Excel formulas, PowerPoint presentations, and email communication.",
    highlights: [
      "Typing speed building (English & Nudi Kannada typing)",
      "MS Word: Official letters, formatting, reports & mail merge",
      "MS Excel: Spreadsheets, VLOOKUP, formulas, data sorting & charts",
      "MS PowerPoint: Presentation design & visual formatting",
      "Internet, cyber safety, email etiquette & cloud document storage"
    ],
    careers: "Office Assistant, Data Entry Operator, Computer Clerk, Front Desk Admin"
  },
  {
    id: "dtp",
    title: "Desktop Publishing & Graphic Design (DTP)",
    kn: "ಡಿಟಿಪಿ & ಗ್ರಾಫಿಕ್ ಡಿಸೈನಿಂಗ್",
    category: "Computer & Skills",
    duration: "3 Months",
    eligibility: "10th / 12th Pass",
    mode: "Practical Computer Labs",
    badge: "Self Employment",
    badgeColor: "bg-amber-100 text-amber-700 border-amber-200",
    image: "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=600&auto=format&fit=crop&q=80",
    desc: "Learn creative graphic design and publishing for brochures, wedding cards, flex banners, and print publications.",
    highlights: [
      "Adobe Photoshop: Photo editing, retouching, and composition",
      "CorelDRAW: Vector illustrations, logo creation, and banner design",
      "PageMaker: Book layout, magazines, and newspaper typesetting",
      "Kannada typing software (Nudi / Baraha) for local printing businesses"
    ],
    careers: "Graphic Designer, DTP Operator, Printing Press Specialist, Freelancer"
  }
];

const CATEGORIES = [
  "All",
  "Teacher Training",
  "Undergraduate (UG)",
  "Postgraduate (PG)",
  "Open Schooling",
  "Computer & Skills"
];

const FAQS = [
  {
    q: "Are the courses and diplomas at AnaBel Institute government approved?",
    a: "Yes. All our teacher training courses (including NTT and Montessori) and distance education programs are government-approved and nationally recognized. Degrees (BA, B.Com, BCA, MA, M.Com, MBA, etc.) are issued by recognized UGC-DEB approved universities, valid for all government and private job applications across India."
  },
  {
    q: "Who is eligible to enrol in the Nursery Teacher Training (NTT) course?",
    a: "Candidates who have passed 10th (SSLC) or 12th (PUC) are eligible. NTT is especially popular among young women, homemakers, and career seekers looking to teach in reputed preschools, kindergarten institutions, and primary schools with competitive salaries."
  },
  {
    q: "Can I pursue a degree or diploma while working or managing a home?",
    a: "Absolutely. With 19+ years of experience, AnaBel Institute specializes in flexible education formats. We provide distance learning materials, weekend doubt-clearing sessions, and flexible exam schedules specifically tailored for working professionals and homemakers."
  },
  {
    q: "Does AnaBel Institute offer job placement assistance?",
    a: "Yes, we provide 100% placement support! Over our 19+ years of service, more than 15,300+ students have been successfully placed in our network of 20,000+ partner schools and organizations across Karnataka and India."
  },
  {
    q: "What is the procedure to apply for a course?",
    a: "You can apply directly online by filling our application form (click the 'Apply Now' button), contact our admissions team on WhatsApp/Call (+91 99644 51828), or visit our campus at 1475, Park Rd, Opp Samskrutha Bhavan, Rangoli Halla, Hassan."
  },
  {
    q: "What documents are required during admission?",
    a: "You will need: (1) Copy of previous qualification marks cards (10th/12th/Degree), (2) Aadhaar card or Govt. Photo ID proof, (3) Recent passport-size photographs, and (4) Transfer / Migration certificate (if applicable)."
  }
];

// ─── MAIN COURSES COMPONENT ───────────────────────────────────────────────────

export default function Courses() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedCourseId, setExpandedCourseId] = useState(null);
  const [openFaqIdx, setOpenFaqIdx] = useState(0);
  const [inquiryModalCourse, setInquiryModalCourse] = useState(null);

  // Filter courses based on category and search query
  const filteredCourses = useMemo(() => {
    return COURSES_DATA.filter(course => {
      const matchesCategory =
        selectedCategory === "All" || course.category === selectedCategory;

      const q = searchQuery.toLowerCase().trim();
      const matchesQuery =
        !q ||
        course.title.toLowerCase().includes(q) ||
        course.kn.toLowerCase().includes(q) ||
        course.desc.toLowerCase().includes(q) ||
        course.category.toLowerCase().includes(q) ||
        course.highlights.some(h => h.toLowerCase().includes(q));

      return matchesCategory && matchesQuery;
    });
  }, [selectedCategory, searchQuery]);

  const toggleExpand = id => {
    setExpandedCourseId(prev => (prev === id ? null : id));
  };

  return (
    <div className="bg-[#fcfbfa] min-h-screen text-gray-800">
      
      {/* ── 1. HERO HEADER ── */}
      <section className="relative bg-gradient-to-b from-[#1800ad]/5 via-white to-transparent pt-12 pb-16 px-4 md:px-8 border-b border-gray-100 overflow-hidden">
        {/* Decorative blur spots */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#1800ad]/5 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute top-12 right-10 w-80 h-80 bg-[#d11210]/5 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-6xl mx-auto text-center relative z-10">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#ffde59]/25 border border-[#ffde59] text-[#1800ad] px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wider mb-5">
            <span className="w-2 h-2 rounded-full bg-[#d11210] animate-pulse" />
            Govt. Approved & Recognized · 19+ Years of Experience
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#1800ad] tracking-tight mb-4">
            Our Courses <span className="text-[#d11210]">| ನಮ್ಮ ಕೋರ್ಸ್‌ಗಳು</span>
          </h1>

          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
            Empowering students, working professionals, and homemakers with government-approved 
            <strong> Nursery Teacher Training (NTT)</strong>, Montessori diplomas, UGC-recognized Distance Degrees (UG/PG), 
            Open Schooling (10th/12th), and job-ready computer certifications in Hassan, Karnataka.
          </p>

          {/* Quick Metrics Bar */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto mb-10">
            {[
              { val: "19+ Years", label: "Educational Excellence", icon: "🏆" },
              { val: "17,200+", label: "Successful Alumni", icon: "🎓" },
              { val: "100%", label: "Placement Support", icon: "💼" },
              { val: "20,000+", label: "Partner Schools", icon: "🏫" }
            ].map((stat, i) => (
              <div
                key={i}
                className="bg-white border border-gray-200/80 rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow text-center"
              >
                <div className="text-2xl mb-1">{stat.icon}</div>
                <div className="text-xl sm:text-2xl font-black text-[#1800ad]">{stat.val}</div>
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mt-0.5">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Search Box */}
          <div className="max-w-2xl mx-auto relative">
            <div className="relative flex items-center">
              <span className="absolute left-4 text-gray-400 text-lg">🔍</span>
              <input
                type="text"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Search courses (e.g. NTT, Montessori, MBA, B.Com, Tally, SSLC)..."
                className="w-full pl-12 pr-12 py-3.5 sm:py-4 rounded-2xl bg-white border-2 border-gray-200 focus:border-[#1800ad] focus:ring-4 focus:ring-[#1800ad]/10 outline-none text-gray-800 text-sm sm:text-base font-medium shadow-sm transition-all"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute right-4 text-gray-400 hover:text-gray-600 text-sm font-bold bg-gray-100 hover:bg-gray-200 w-6 h-6 rounded-full flex items-center justify-center transition-colors"
                  title="Clear search"
                >
                  ✕
                </button>
              )}
            </div>
            {searchQuery && (
              <p className="text-xs text-left text-gray-500 mt-2 ml-2">
                Showing results for <span className="font-semibold text-[#1800ad]">"{searchQuery}"</span> ({filteredCourses.length} found)
              </p>
            )}
          </div>
        </div>
      </section>

      {/* ── 2. CATEGORY TABS & FILTER ── */}
      <section className="sticky top-[70px] md:top-[80px] z-40 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm py-3 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-4 overflow-x-auto no-scrollbar">
          <div className="flex items-center gap-2 shrink-0 py-1">
            {CATEGORIES.map(cat => {
              const count =
                cat === "All"
                  ? COURSES_DATA.length
                  : COURSES_DATA.filter(c => c.category === cat).length;
              const isActive = selectedCategory === cat;

              return (
                <button
                  key={cat}
                  onClick={() => {
                    setSelectedCategory(cat);
                  }}
                  className={`px-4 py-2 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap transition-all duration-200 flex items-center gap-2 ${
                    isActive
                      ? "bg-[#1800ad] text-white shadow-md shadow-[#1800ad]/20 scale-102"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200/80 hover:text-gray-900"
                  }`}
                >
                  <span>{cat}</span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold ${
                      isActive ? "bg-white/20 text-white" : "bg-gray-200 text-gray-600"
                    }`}
                  >
                    {count}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="hidden lg:flex items-center gap-3 shrink-0 text-xs font-semibold text-gray-500">
            <span>Showing: <strong className="text-[#1800ad]">{filteredCourses.length}</strong> Courses</span>
          </div>
        </div>
      </section>

      {/* ── 3. COURSES GRID ── */}
      <section className="max-w-6xl mx-auto px-4 md:px-6 py-12">
        {filteredCourses.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-3xl border border-gray-200 p-8 shadow-sm">
            <div className="text-5xl mb-4">🔍</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">No matching courses found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto mb-6">
              We couldn't find any courses matching "{searchQuery}". Try searching for NTT, Montessori, BA, MBA, or Tally.
            </p>
            <button
              onClick={() => {
                setSearchQuery("");
                setSelectedCategory("All");
              }}
              className="bg-[#1800ad] text-white px-5 py-2.5 rounded-xl font-bold text-sm hover:bg-[#1800ad]/90 transition"
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {filteredCourses.map(course => {
              const isExpanded = expandedCourseId === course.id;

              return (
                <div
                  key={course.id}
                  className="bg-white rounded-2xl border border-gray-200/80 overflow-hidden shadow-sm hover:shadow-xl hover:border-[#1800ad]/40 transition-all duration-300 flex flex-col group"
                >
                  {/* Image Banner */}
                  <div className="relative h-48 overflow-hidden bg-gray-100">
                    <img
                      src={course.image}
                      alt={course.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />

                    {/* Badge */}
                    <div className="absolute top-3 left-3">
                      <span className={`text-[11px] font-bold px-3 py-1 rounded-full border shadow-sm ${course.badgeColor}`}>
                        {course.badge}
                      </span>
                    </div>

                    {/* Category pill */}
                    <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-md text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                      {course.category}
                    </div>

                    {/* Duration chip on image */}
                    <div className="absolute bottom-3 left-3 text-white text-xs font-semibold flex items-center gap-1.5 drop-shadow">
                      <span className="bg-[#ffde59] text-gray-900 px-2 py-0.5 rounded font-black text-[11px]">
                        ⏱ {course.duration}
                      </span>
                      <span className="bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded text-[11px]">
                        {course.mode}
                      </span>
                    </div>
                  </div>

                  {/* Content Body */}
                  <div className="p-5 flex-1 flex flex-col">
                    <h3 className="text-lg font-bold text-gray-900 group-hover:text-[#1800ad] transition-colors leading-snug">
                      {course.title}
                    </h3>
                    <p
                      className="text-xs font-semibold text-[#d11210] mt-0.5 mb-3"
                      style={{ fontFamily: "'Noto Sans Kannada', sans-serif" }}
                    >
                      {course.kn}
                    </p>

                    <p className="text-xs text-gray-600 leading-relaxed mb-4">
                      {course.desc}
                    </p>

                    {/* Meta info tags */}
                    <div className="bg-gray-50 border border-gray-100 rounded-xl p-3 mb-4 space-y-1.5 text-xs text-gray-600">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-400 font-semibold uppercase text-[10px] tracking-wider">Eligibility</span>
                        <span className="font-bold text-gray-800">{course.eligibility}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-400 font-semibold uppercase text-[10px] tracking-wider">Placement</span>
                        <span className="font-bold text-green-700">100% Support</span>
                      </div>
                    </div>

                    {/* Expandable Syllabus / Highlights */}
                    {isExpanded && (
                      <div className="border-t border-gray-100 pt-3 mt-1 mb-4 space-y-3 animate-fadeIn">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-wider text-[#1800ad] mb-2">
                            Key Highlights & Topics:
                          </p>
                          <ul className="space-y-1.5 text-xs text-gray-600">
                            {course.highlights.map((item, idx) => (
                              <li key={idx} className="flex items-start gap-2">
                                <span className="text-[#d11210] font-bold text-xs mt-0.5">✓</span>
                                <span>{item}</span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {course.careers && (
                          <div className="bg-amber-50/70 border border-amber-200/60 rounded-lg p-2.5 text-xs">
                            <span className="font-bold text-amber-900">Career Paths: </span>
                            <span className="text-amber-800">{course.careers}</span>
                          </div>
                        )}
                      </div>
                    )}

                    <button
                      onClick={() => toggleExpand(course.id)}
                      className="text-xs font-bold text-[#1800ad] hover:text-[#d11210] flex items-center justify-between py-1 mb-4 border-b border-dashed border-gray-200 transition-colors"
                    >
                      <span>{isExpanded ? "Hide Syllabus & Details ▲" : "View Syllabus & Highlights ▼"}</span>
                      <span className="text-[11px] underline">
                        {isExpanded ? "Less" : "Explore"}
                      </span>
                    </button>

                    {/* Action Buttons */}
                    <div className="mt-auto pt-2 grid grid-cols-2 gap-2">
                      <button
                        onClick={() => setInquiryModalCourse(course)}
                        className="w-full bg-[#1800ad] hover:bg-[#120087] text-white font-bold text-xs py-2.5 px-3 rounded-xl transition duration-200 shadow-sm text-center flex items-center justify-center gap-1.5"
                      >
                        <span>Enquire</span>
                        <span>💬</span>
                      </button>

                      <a
                        href="https://forms.gle/KiAg5XBjbgeD4FD98"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-[#d11210] hover:bg-[#a30e0c] text-white font-bold text-xs py-2.5 px-3 rounded-xl transition duration-200 shadow-sm text-center flex items-center justify-center gap-1.5"
                      >
                        <span>Apply</span>
                        <span>📋</span>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      {/* ── 4. FLAGSHIP SPOTLIGHT (NTT & TEACHER TRAINING) ── */}
      <section className="bg-gradient-to-r from-[#1800ad] to-[#0f006d] text-white py-16 px-4 md:px-8 relative overflow-hidden">
        {/* Decorative background circle */}
        <div className="absolute right-0 top-0 w-96 h-96 bg-white/5 rounded-full blur-2xl pointer-events-none" />

        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
          <div className="lg:col-span-7 space-y-5">
            <span className="inline-block bg-[#ffde59] text-[#1800ad] text-xs font-black px-3.5 py-1 rounded-full uppercase tracking-wider">
              ⭐ Karnataka's Leading NTT Academy
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight">
              Start Your Teaching Career with Govt. Approved NTT & Montessori
            </h2>
            <p className="text-sm sm:text-base text-gray-200 leading-relaxed">
              For over <strong>19+ years</strong>, AnaBel Institute has been the premier destination in Hassan, Karnataka 
              for women and aspiring teachers. Our government-recognized Nursery Teacher Training course gives you practical 
              classroom experience, child psychology fundamentals, and guaranteed placement in reputed schools.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              {[
                "Government Approved Diploma Certificate",
                "100% Placement Assistance in Top Schools",
                "Weekend & Distance Learning for Homemakers",
                "Affordable Fees with Easy Installment Options",
                "Montessori Lab & Live School Internships",
                "Recognized Across Karnataka & All Over India"
              ].map((point, idx) => (
                <div key={idx} className="flex items-center gap-2 text-xs sm:text-sm font-medium text-gray-100">
                  <span className="text-[#ffde59] font-bold text-base">✓</span>
                  <span>{point}</span>
                </div>
              ))}
            </div>

            <div className="pt-4 flex flex-wrap gap-3">
              <a
                href="https://forms.gle/KiAg5XBjbgeD4FD98"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#d11210] hover:bg-[#b00f0d] text-white font-bold text-sm px-6 py-3 rounded-xl transition shadow-lg inline-flex items-center gap-2"
              >
                <span>Apply for NTT Course</span>
                <span>→</span>
              </a>
              <a
                href="tel:+919964451828"
                className="bg-white/10 hover:bg-white/20 text-white border border-white/30 font-bold text-sm px-5 py-3 rounded-xl transition inline-flex items-center gap-2"
              >
                <span>📞 Call +91 99644 51828</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-white text-gray-800 rounded-3xl p-6 sm:p-8 shadow-2xl border-4 border-[#ffde59]">
              <div className="text-center mb-6">
                <span className="text-xs font-bold uppercase tracking-widest text-[#d11210] bg-red-50 px-3 py-1 rounded-full">
                  Fast Admission Enquiries
                </span>
                <h3 className="text-xl sm:text-2xl font-black text-gray-900 mt-2">
                  Get Free Counseling
                </h3>
                <p className="text-xs text-gray-500 mt-1">
                  Speak with our expert academic advisors today
                </p>
              </div>

              <div className="space-y-4">
                <a
                  href="https://wa.me/919964451828?text=Hello%20AnaBel%20Institute%2C%20I%20would%20like%20information%20about%20your%20courses."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#25D366] hover:bg-[#20ba59] text-white font-bold text-sm py-3.5 px-4 rounded-xl flex items-center justify-center gap-2.5 transition shadow"
                >
                  <span className="text-lg">💬</span> Chat on WhatsApp
                </a>

                <a
                  href="tel:+919964451828"
                  className="w-full bg-[#1800ad] hover:bg-[#120087] text-white font-bold text-sm py-3.5 px-4 rounded-xl flex items-center justify-center gap-2.5 transition shadow"
                >
                  <span className="text-lg">📞</span> Call: +91 99644 51828
                </a>

                <a
                  href="tel:+918884618113"
                  className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold text-sm py-3.5 px-4 rounded-xl flex items-center justify-center gap-2.5 transition"
                >
                  <span className="text-lg">📱</span> Alt: +91 88846 18113
                </a>
              </div>

              <div className="mt-6 pt-5 border-t border-gray-100 text-center">
                <p className="text-[11px] text-gray-500">
                  📍 Campus: 1475, Park Rd, Opp Samskrutha Bhavan, Rangoli Halla, Hassan - 573201
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── 5. ADMISSION PROCESS (5 SIMPLE STEPS) ── */}
      <section className="max-w-6xl mx-auto px-4 md:px-6 py-16">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-[#d11210] bg-red-50 border border-red-200 px-3 py-1 rounded-full">
            How It Works · ಸರಳ ಪ್ರವೇಶ ಪ್ರಕ್ರಿಯೆ
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mt-3">
            5 Simple Steps to Enrol
          </h2>
          <p className="text-sm sm:text-base text-gray-500 max-w-xl mx-auto mt-2">
            Joining AnaBel Institute is hassle-free. Our admission counselors will guide you at every single step.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {[
            {
              step: "01",
              title: "Free Counseling",
              kn: "ಉಚಿತ ಮಾರ್ಗದರ್ಶನ",
              desc: "Discuss your career goals with our counselors and choose the right course."
            },
            {
              step: "02",
              title: "Submit Documents",
              kn: "ದಾಖಲೆಗಳ ಸಲ್ಲಿಕೆ",
              desc: "Provide copies of marks cards, ID proof, and photographs online or on campus."
            },
            {
              step: "03",
              title: "Confirm Enrolment",
              kn: "ಪ್ರವೇಶ ದೃಢೀಕರಣ",
              desc: "Pay nominal fees with easy installment options and receive your admission confirmation."
            },
            {
              step: "04",
              title: "Classes & Materials",
              kn: "ತರಗತಿಗಳು & ಪುಸ್ತಕಗಳು",
              desc: "Receive comprehensive textbooks and attend weekend/regular sessions."
            },
            {
              step: "05",
              title: "Certificate & Job",
              kn: "ಪ್ರಮಾಣಪತ್ರ & ಉದ್ಯೋಗ",
              desc: "Appear for exams, receive your Govt. recognized certificate, and get placed."
            }
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-gray-200/80 p-5 shadow-sm hover:border-[#1800ad] hover:shadow-md transition-all relative flex flex-col"
            >
              <div className="text-3xl font-black text-[#ffde59] mb-2">{item.step}</div>
              <h4 className="font-bold text-gray-900 text-sm mb-0.5">{item.title}</h4>
              <p
                className="text-xs text-[#d11210] font-semibold mb-2"
                style={{ fontFamily: "'Noto Sans Kannada', sans-serif" }}
              >
                {item.kn}
              </p>
              <p className="text-xs text-gray-500 leading-relaxed mt-auto">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ── 6. FREQUENTLY ASKED QUESTIONS (FAQ) ── */}
      <section className="bg-gray-50/80 border-t border-b border-gray-200/80 py-16 px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-widest text-[#1800ad] bg-blue-50 border border-blue-200 px-3 py-1 rounded-full">
              Got Questions? · ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೋತ್ತರಗಳು
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mt-3">
              Frequently Asked Questions
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Everything you need to know about course admissions, validity, and placements.
            </p>
          </div>

          <div className="space-y-3">
            {FAQS.map((faq, idx) => {
              const isOpen = openFaqIdx === idx;
              return (
                <div
                  key={idx}
                  className="bg-white rounded-2xl border border-gray-200/80 overflow-hidden shadow-sm transition-all"
                >
                  <button
                    onClick={() => setOpenFaqIdx(isOpen ? null : idx)}
                    className="w-full text-left p-5 flex items-center justify-between gap-4 font-bold text-gray-900 hover:text-[#1800ad] transition-colors"
                  >
                    <span className="text-sm sm:text-base flex items-center gap-3">
                      <span className="text-[#1800ad] font-black text-sm">Q{idx + 1}.</span>
                      <span>{faq.q}</span>
                    </span>
                    <span className="text-xl text-gray-400 shrink-0 font-mono">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-5 pb-5 pt-1 text-xs sm:text-sm text-gray-600 leading-relaxed border-t border-gray-50 bg-gray-50/40">
                      {faq.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── 7. BOTTOM CALL TO ACTION ── */}
      <section className="max-w-6xl mx-auto px-4 md:px-6 py-16">
        <div className="bg-gradient-to-r from-[#d11210] to-[#a30e0c] rounded-3xl p-8 sm:p-12 text-white shadow-xl relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="space-y-3 max-w-xl">
            <span className="bg-[#ffde59] text-gray-900 font-bold text-xs uppercase px-3 py-1 rounded-full">
              Admissions Open 2025-26
            </span>
            <h3 className="text-2xl sm:text-3xl font-black leading-tight">
              Ready to Take the Next Step in Your Career?
            </h3>
            <p className="text-sm text-red-100 leading-relaxed">
              Seats are limited for the upcoming batch. Get in touch with our admissions office in Hassan 
              to reserve your seat or apply directly online.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
            <a
              href="https://forms.gle/KiAg5XBjbgeD4FD98"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#ffde59] hover:bg-[#f5d038] text-gray-900 font-black text-sm px-6 py-3.5 rounded-xl transition text-center shadow-md"
            >
              📋 Apply Online Now
            </a>
            <a
              href="tel:+919964451828"
              className="bg-white hover:bg-gray-100 text-[#d11210] font-black text-sm px-6 py-3.5 rounded-xl transition text-center shadow-md"
            >
              📞 Call Admissions
            </a>
          </div>
        </div>
      </section>

      {/* ── INQUIRY MODAL (POPUP) ── */}
      {inquiryModalCourse && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-3xl max-w-lg w-full p-6 sm:p-8 shadow-2xl relative border border-gray-100">
            <button
              onClick={() => setInquiryModalCourse(null)}
              className="absolute top-5 right-5 text-gray-400 hover:text-gray-700 bg-gray-100 hover:bg-gray-200 w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm transition"
            >
              ✕
            </button>

            <div className="mb-5">
              <span className="text-[11px] font-bold uppercase tracking-wider text-[#d11210] bg-red-50 px-2.5 py-1 rounded-full">
                Course Enquiry
              </span>
              <h3 className="text-xl font-black text-gray-900 mt-2">
                {inquiryModalCourse.title}
              </h3>
              <p className="text-xs text-gray-500 mt-0.5">
                Duration: {inquiryModalCourse.duration} · Mode: {inquiryModalCourse.mode}
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-4 mb-6 border border-gray-100 space-y-2 text-xs">
              <p className="font-semibold text-gray-700">How would you like to connect?</p>
              <p className="text-gray-500">
                Our admissions counselor will answer your questions regarding syllabus, fees, and batch timings.
              </p>
            </div>

            <div className="space-y-3">
              <a
                href={`https://wa.me/919964451828?text=Hello%20AnaBel%20Institute%2C%20I%20want%20details%20about%20the%20${encodeURIComponent(
                  inquiryModalCourse.title
                )}%20course.`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#25D366] hover:bg-[#20ba59] text-white font-bold text-sm py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition shadow"
              >
                <span>💬</span> Connect on WhatsApp
              </a>

              <a
                href="tel:+919964451828"
                className="w-full bg-[#1800ad] hover:bg-[#120087] text-white font-bold text-sm py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition shadow"
              >
                <span>📞</span> Call +91 99644 51828
              </a>

              <a
                href="https://forms.gle/KiAg5XBjbgeD4FD98"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#d11210] hover:bg-[#a30e0c] text-white font-bold text-sm py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition shadow"
              >
                <span>📋</span> Open Online Application Form
              </a>
            </div>

            <p className="text-[11px] text-gray-400 text-center mt-4">
              AnaBel Institute · 19+ Years of Educational Excellence in Hassan
            </p>
          </div>
        </div>
      )}

    </div>
  );
}
